import { Card, ListLayout } from '@ingrid/luterkort-react';

import { useTranslation } from '~src/i18n/use-translation';

import { ShipmentTemplateDetails } from '../types';

interface Props {
  template: ShipmentTemplateDetails;
}

export function Metadata(props: Props) {
  const { template } = props;

  const { t } = useTranslation();

  const meta = Object.entries(template.meta ?? {}).map(([key, value]) => ({ key, value }));

  if (!meta.length) {
    return null;
  }

  return (
    <Card.List>
      <Card.Wrapper>
        <Card.Header>{t('common.metadata')}</Card.Header>
        <Card.Content>
          <ListLayout.Column>
            <ListLayout.Row>
              <ListLayout.Column>
                {meta.map(({ key, value }) => (
                  <ListLayout.Row key={key}>
                    <ListLayout.Stack>
                      <ListLayout.SecondaryText>{key}</ListLayout.SecondaryText>
                      <ListLayout.PrimaryText>{value}</ListLayout.PrimaryText>
                    </ListLayout.Stack>
                  </ListLayout.Row>
                ))}
              </ListLayout.Column>
            </ListLayout.Row>
          </ListLayout.Column>
        </Card.Content>
      </Card.Wrapper>
    </Card.List>
  );
}
